var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLithuania = function SvgLithuania(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 3",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#C1272D",
    width: 5,
    height: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#006A44",
    width: 5,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FDB913",
    width: 5,
    height: 1
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLithuania);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1IDMiPgo8cmVjdCBmaWxsPSIjQzEyNzJEIiB3aWR0aD0iNSIgaGVpZ2h0PSIzIi8+CjxyZWN0IGZpbGw9IiMwMDZBNDQiIHdpZHRoPSI1IiBoZWlnaHQ9IjIiLz4KPHJlY3QgZmlsbD0iI0ZEQjkxMyIgd2lkdGg9IjUiIGhlaWdodD0iMSIvPgo8L3N2Zz4K";